



















































import Vue from 'vue'
import Component from 'vue-class-component';
import HomeChallengeButton from '@/components/home/HomeChallengeButton.vue';

@Component({
  components: {
    HomeChallengeButton,
  }
})
export default class HomeCovi19 extends Vue {

  descriptions = ' Lorem ipsum dolor sit amet, consectetur adipisicing elit. Asperiores at consectetur expedita fugiat harum\n' +
          '              in, magni numquam repudiandae suscipit voluptatibus. Ad alias debitis doloribus ea expedita fugit quia\n' +
          '              quidem sit?';

}
